import {
  DARK_WHITE,
  FADED_GREY,
  LIGHT_GRAY,
  LIGHT_GREY_1,
  SHADOW_CONTAINER,
  SHADOW_DARK,
  SHADOW_LEVEL_2,
} from './Colors.constants';

export const BOX_SHADOW = `0 2px 4px 0 ${FADED_GREY}`;
export const BOX_SHADOW_ARROW = `0 0 3px 2px ${DARK_WHITE}`;
export const BOX_SHADOW_TOP = `0 -2px 4px 0 ${LIGHT_GRAY}`;
export const BOX_SHADOW_TOP_V2 = `0px 2px 8px 0px ${SHADOW_DARK}`;
export const BOX_SHADOW_ACTIVE = `0 2px 6px 2px ${SHADOW_LEVEL_2}`;
export const BOX_SHADOW_HOVER = `0 2px 10px 0 ${SHADOW_CONTAINER}`;
export const CONTAINER_BOX_SHADOW = `2px 2px 11px 0 ${SHADOW_CONTAINER}`;
export const BOX_SHADOW_TOOLTIP =
  '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)';
export const BOX_SHADOW_TOOLTIP_1 = `0 2px 4px 0 ${LIGHT_GREY_1}`;

export const BOX_SHADOW_UNDIRECTED = `0 0px 5px 0 ${DARK_WHITE}`;
export const BOX_SHADOW_UNDERLINE = `0px 2px 6px -6px ${FADED_GREY}`;
export const TRANSITION_MATERIAL = '250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms';
export const OPTIONS_MENU_SHADOW =
  '1px 0px 0px -3px rgba(0,0,0,0.05), 0px 1px 4px 1px rgba(0,0,0,0.03)';
export const POPOVER_SHADOW =
  '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)';
